export default function ManageTeam(){
    return(
        <section>ManageTeam</section>
    );
}